/* eslint-disable react-hooks/rules-of-hooks */
"use client"

import React, { useEffect } from "react"
import Spinner from "@/components/Spinner"

export default function loading() {
	return (
		<div className='flex h-screen flex-col items-center justify-center'>
			<div
				style={{
					width: "100%",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<Spinner />
			</div>
		</div>
	)
}
